import { getters } from "@/constants/state";

export default {
  [getters.HRNOTIFICATIONS_GETTER]: (state) => state.hrNotifications,
};
